<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-sm-8">
          <h4 class="title">Terminals</h4>
        </div>

        <div class="col-sm-4 text-right">
          <button class="btn btn-default" @click="showTerminalsExportModal">
            <i class="fa fa-download mr-2"></i> Export
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">

      <active-filter-list :activeFilters="activeFilters" :tableName="tableName" @remove-filter="removeFilter"
        @clear-filters="clearFilters"></active-filter-list>

      <v-server-table :name="tableName" :url="`/v1/terminals`" :columns="columns" :options="options" :ref="tableName"
        @filter="addToActiveFilters">
        <template slot="id" slot-scope="props">
          <code>{{ props.row.id }}</code>
        </template>

        <template slot="serialNumber" slot-scope="props">
          <code>{{ props.row.serialNumber }}</code>
        </template>

        <template slot="reference" slot-scope="props">
          <code>{{ props.row.reference }}</code>
        </template>

        <template slot="customReference" slot-scope="props">{{ props.row.customReference }}</template>

        <template v-if="props.row.currentAllocation" slot="currentAllocation.createdAt" slot-scope="props">
          <div>{{ props.row.currentAllocation.createdAt | moment('YYYY-MM-DD HH:mm A') }}</div>
        </template>

        <div slot="filter__lastConnectionAt">
          <date-range-picker class="picker" ref="picker" :opens="opens" v-model="dateRange" @update="updateValues"
            style="z-index: 1; position:inherit;">
            <template class="picker-dates" v-slot:input="picker" style="min-width: 350px;">
              {{ picker.startDate ? `${picker.startDate.toISOString().split('T')[0]} -` : "Select date range" }}
              {{ picker.endDate ? picker.endDate.toISOString().split('T')[0] : "" }}
            </template>
          </date-range-picker>
        </div>

        <template v-if="props.row.lastConnectionAt" slot="lastConnectionAt" slot-scope="props">
          <div>{{ props.row.lastConnectionAt | moment('from', 'now') }}</div>
        </template>

        <template slot="reportedConfiguration.isUpToDate" slot-scope="props">
          <div>
            <span v-if="props.row.reportedConfiguration && props.row.reportedConfiguration.isUpToDate"
              class="text-success">
              <i class="fa fa-check"></i>&nbsp; Up to date
            </span>
            <span v-else-if="props.row.reportedConfiguration && !props.row.reportedConfiguration.isUpToDate"
              class="text-danger">
              <i class="fa fa-exclamation-triangle"></i>&nbsp; Out of date
            </span>
            <span v-else class="text-warning">
              <i class="fa fa-question-circle"></i>&nbsp; Status unknown
            </span>
          </div>
        </template>

        <template slot="links" slot-scope="props">
          <router-link :to="`/terminals/${props.row.id}`" class="btn btn-default btn-sm">
            View &nbsp;
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </template>
      </v-server-table>
    </div>

    <terminals-export-modal ref="terminalsExportModal"></terminals-export-modal>
  </div>
</template>
<script>
import _ from "lodash";

import { requestAdapter } from "../../../../helpers/tableHelpers";
import TerminalsExportModal from "src/components/Dashboard/Views/Pages/Terminals/TerminalsExportModal.vue";
import ActiveFilterList from "src/components/UIComponents/ActiveFilterList.vue";

// datepicker table filter dependencies
import jquery from "jquery";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { Event } from 'vue-tables-2-premium'

window.$ = jquery;
window.moment = moment;

const columns = [
  "id",
  "serialNumber",
  "currentAllocation.createdAt",
  "lastConnectionAt",
  "reference",
  "customReference",
  "reportedConfiguration.isUpToDate",
  "links"
];

export default {
  name: "TerminalsList",
  components: {
    TerminalsExportModal,
    ActiveFilterList,
    DateRangePicker
  },
  computed: {
    operator: function () {
      return this.$store.state.operator;
    }
  },
  data() {
    return {
      columns,
      tableName: "terminalsList",
      activeFilters: [],
      options: {
        name: this.tableName,
        columnsDropdown: false,
        headings: {
          id: "Terminal ID",
          serialNumber: "Serial Number",
          "currentAllocation.createdAt": "Allocated at",
          lastConnectionAt: "Last online",
          "reportedConfiguration.isUpToDate": "Software status",
          customReference: "Custom reference"
        },
        sortable: _.initial(columns),
        customFilters: ["lastConnectionAt"],
        filterable: ["serialNumber", "reference", "customReference"],
        listColumns: {
          isUpToDate: [
            {
              id: "true",
              text: "Up to date"
            },
            {
              id: "false",
              text: "Out of date"
            }
          ]
        },
        requestAdapter
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      opens: 'right'
    };
  },
  methods: {
    showTerminalsExportModal() {
      this.$refs.terminalsExportModal.showModal();
    },
    clearFilters() {
      this.$refs[this.tableName].resetQuery();
      this.$refs[this.tableName].resetCustomFilters();
      this.activeFilters = [];
    },
    containsObject(obj, list) {
      for (const i in list) {
        if (obj.name === list[i].name) {
          return true;
        }
      }
      return false;
    },
    removeFilter(filter) {
      if (filter.name === 'date') {
        filter.name = 'lastConnectionAt';
        Event.$emit(`vue-tables.${this.tableName}.filter::${filter.name}`, "");
      } else {
        const filterObj = {}
        filterObj[filter.name] = '';
        this.$refs[this.tableName].setFilter(filterObj);
      }
    },
    addToActiveFilters(filter) {
      let isDuplicate = this.containsObject(filter, this.activeFilters)
      if (filter.value !== '' && !isDuplicate) {
        this.activeFilters.push(filter)
      } else if (filter.value === '') {
        const index = this.activeFilters.indexOf(filter)
        this.activeFilters.splice(index, 1)
      }
    },
    loadActiveFilters() {
      const tableData = this.$refs[this.tableName].getRequestParams();
      const activeQueries = tableData['query'];

      if (tableData['lastConnectionAt'] !== null || '') {
        activeQueries.date = tableData['capturedAt']
      }

      for (let query in activeQueries) {
        if (activeQueries[query] !== '') {
          const queryObj = { name: query, value: activeQueries[query] };
          this.activeFilters.push(queryObj);
        }
      }
    },
    updateValues(vals) {
      let filter = { name: "date", value: vals };
      let isDuplicate = this.containsObject(filter, this.activeFilters);
      if (!isDuplicate) {
        this.activeFilters.push(filter);
      }
      Event.$emit(`vue-tables.${this.tableName}.filter::lastConnectionAt`, { start: moment(vals.startDate).startOf('day'), end: moment(vals.endDate).endOf('day') });
    }
  },
  mounted() {
    this.loadActiveFilters();
  }
};
</script>
